import DOMPurify from 'dompurify'

export interface Notificacao {
  id: number
  titulo: string
  texto: string
  dataCriacao: string
  dataAtualizado: string
  local: string
}

export const useNotificacoes = () => {
  const config = useRuntimeConfig()

  const fetchNotificacoes = async (local?: string): Promise<Notificacao[]> => {
    try {
      const query = local ? `?local=${encodeURIComponent(local)}` : ''
      const response = await $fetch<Notificacao[]>(
        // `${config.public.backofficeApiBaseUrl}/portal/notificacoes${query}`
        `${config.public.backofficeApiBaseUrl}/portal/notificacoes`
      )

      if (!Array.isArray(response)) {
        return []
      }

      return response.map(item => ({
        ...item,
        texto: DOMPurify.sanitize(item.texto || '')
      }))
    }
    catch (error) {
      console.error('Erro ao buscar notificações:', error)
      return []
    }
  }

  return {
    fetchNotificacoes
  }
}